/**
 * iter413c — EshopContext
 * ────────────────────────
 * Globální kontext s vybraným eshopem napříč CRM "E-shop" sekcí.
 * - Načte seznam aktivních eshopů pro switcher
 * - Persistuje výběr do localStorage (klíč `selected_eshop_id`)
 * - Default = první eshop z listu (typicky 'default')
 */
import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const STORAGE_KEY = "selected_eshop_id";

const EshopContext = createContext({
  eshops: [],
  selected: null,
  selectEshop: () => {},
  reload: () => {},
  loading: true,
});

export function EshopProvider({ children }) {
  const [eshops, setEshops] = useState([]);
  const [selectedId, setSelectedId] = useState(() => localStorage.getItem(STORAGE_KEY) || null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${BACKEND_URL}/api/v1/admin/eshops/active`, { withCredentials: true });
      const list = Array.isArray(r.data) ? r.data : [];
      setEshops(list);
      // Pick default selection
      if (list.length) {
        const stored = localStorage.getItem(STORAGE_KEY);
        const exists = stored && list.find((e) => e.eshop_id === stored);
        if (!exists) {
          setSelectedId(list[0].eshop_id);
          localStorage.setItem(STORAGE_KEY, list[0].eshop_id);
        } else {
          setSelectedId(stored);
        }
      }
    } catch {
      setEshops([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { reload(); }, [reload]);

  const selectEshop = useCallback((id) => {
    setSelectedId(id);
    localStorage.setItem(STORAGE_KEY, id);
  }, []);

  const selected = eshops.find((e) => e.eshop_id === selectedId) || eshops[0] || null;

  return (
    <EshopContext.Provider value={{ eshops, selected, selectEshop, reload, loading }}>
      {children}
    </EshopContext.Provider>
  );
}

export function useEshop() {
  return useContext(EshopContext);
}
